export class ColaTrabajoOCR {
    id: number;
    ACTIVO: boolean;
    FECHA: Date;
    NAMEFILE: string;
    GUID_JOB: string;
    ERROR: string;

    static toModel(json: string): ColaTrabajoOCR {
        const data = JSON.parse(json);
        const toReturn = new ColaTrabajoOCR();
        toReturn.ACTIVO = data.ACTIVO;
        toReturn.FECHA = data.FECHA;
        toReturn.NAMEFILE = data.NAMEFILE;
        toReturn.GUID_JOB = data.GUID_JOB;
        toReturn.ERROR = data.ERROR;
        return toReturn;
    }
}
